import {
  useCallbackWithAnalytics,
  withAnalyticsEvents,
  WithAnalyticsEventsProps
} from '@atlaskit/analytics-next';
import { B400, N600 } from '@atlaskit/theme/colors';
import React, { MouseEvent } from 'react';
import styled from 'styled-components';
import { getParameterByName, parseProductKey, trackingData } from '../tracking';

export type SiteLinkProps = {
  readonly site: string;
  readonly name: string;
  readonly domRootId?: string;
} & WithAnalyticsEventsProps;

function SiteLink({ site, name, domRootId }: SiteLinkProps) {
  const { hostname } = new URL(site);
  const index = hostname.indexOf('.');

  const subdomain = hostname.substring(0, index);
  const rest = hostname.substring(index);

  const trackAndFollowUrl = (label: string, domain: string) => {
    const analyticsData = Object.assign(
      { ...trackingData.siteLink },
      {
        magnoliaComponentId: domRootId,
        atlOrigin: getParameterByName('atlOrigin', domain),
        productKey: parseProductKey(label)
      }
    );

    return useCallbackWithAnalytics((event: MouseEvent) => {
      event.preventDefault();
      event.stopPropagation();
      window.location.assign(domain);
    }, analyticsData);
  };

  return (
    <Link href={site} onClick={trackAndFollowUrl(name, site)}>
      <SubDomain>{subdomain}</SubDomain>
      <span>{rest}</span>
    </Link>
  );
}

export const Link = styled.a`
  color: ${N600};
  text-decoration: none;
`;

export const SubDomain = styled.span`
  color: ${B400};
`;

export default withAnalyticsEvents()(SiteLink);
